export class OrganizationCourseCatalogModel {
	id: number;
	title: string;
}
